import React from "react";
import styled from "styled-components";
import TableFields from "../../constants/PendingDeductions/TableFields.json";
import Table from "../Common/Table";
import { connect } from "react-redux";
import { Pill } from "../../constants/assets/containers";

const PendingDeductionList = (props) => {
  const { pendingDeductions } = props;

  const getFieldValue = (obj, key, index) => {
    switch (key) {
      case "pending":
      case "compulsory":
        return (
          <div className="flex items-center justify-center">
            <Pill isFalse={!obj[key]}>{obj[key] ? "Yes" : "No"}</Pill>
          </div>
        );
      case "priority":
        return obj[key];
      default:
        return obj[key] ? obj[key] : "-";
    }
  };
  return (
    <PendingDeductionListContainer>
      <Table
        list={pendingDeductions}
        getFieldValue={getFieldValue}
        fields={TableFields}
      />
    </PendingDeductionListContainer>
  );
};
const PendingDeductionListContainer = styled.section`
  height: calc(100vh - 215px);
`;

function mapStateToProps(state) {
  return {};
}
function mapDispatchToProps(dispatch) {
  return {};
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PendingDeductionList);
